import React from 'react'; 
import '../styles.scss';
import SupplierList from './SuppliersList';
import LayoutPage from '../../../layouts/Main';

export default function AllSuppliers() {
  return (
    <LayoutPage>
      <SupplierList />
    </LayoutPage>
  );
}